import { FormsLangToLangMap } from 'forms-utils-lib/language/LanguageConstants';
import { getFormsLangToLangMap } from 'forms-utils-lib/language/getFormsLangToLangMap';
export const formsLangToLang = getFormsLangToLangMap(FormsLangToLangMap);